import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { closedCoworkingAdModalMini } from '../../../../serp/state/coworking_experiments/coworkingAdModalMini';

import { IAppState } from '../../../state';

import { CoworkingModalAdMini as CoworkingModalAdMiniComponent } from './CoworkingModalAdMini';

interface ICoworkingModalAdMiniProps {
  className?: string;
}

export const CoworkingModalAdMini: React.FC<ICoworkingModalAdMiniProps> = props => {
  const isCoworkingModalAdMiniVisible = useSelector<IAppState, boolean>(
    state => state.coworkingExperiments.coworkingAdModalMini.isOpen,
  );
  const dispatch = useDispatch();
  const onClose = React.useCallback(() => {
    dispatch(closedCoworkingAdModalMini());
  }, []);

  if (!isCoworkingModalAdMiniVisible) {
    return null;
  }

  return <CoworkingModalAdMiniComponent {...props} onClose={onClose} />;
};

CoworkingModalAdMini.displayName = 'CoworkingModalAdMiniContainer';
